import React from 'react';
import {
  ArticleHeading3,
  InformationTooltip,
  UIText2,
  IconFunctionalInformationCircle16,
  useDeviceType,
  ArticleHeading4,
} from '@cian/ui-kit';
import { ConditionalWrapper } from '@cian/conditional-component';
import { PskTooltipContent } from './components/PskTooltipContent';
import { transformNumToString } from 'shared/utils/common';
import { PERCENT } from 'shared/constants/common';
import styles from './styles.css';
import { IPsk } from 'shared/types/common/offer';

export interface IPskBlockProps extends IPsk {}

export const PskBlock: React.FC<IPskBlockProps> = ({ from, to }) => {
  const isDesktop = useDeviceType() === 'desktop';

  return (
    <>
      <div className={styles['title']}>
        <UIText2 color={'current_color'}>ПСК</UIText2>
        <InformationTooltip
          placement={'right-start'}
          content={<PskTooltipContent />}
          header={'Полная стоимость кредита'}
        >
          <IconFunctionalInformationCircle16 color={'current_color'} />
        </InformationTooltip>
      </div>
      <div className={styles['description']}>
        <ConditionalWrapper
          if={isDesktop}
          ThenComponent={({ children }) => <ArticleHeading4 color={'current_color'}>{children}</ArticleHeading4>}
          ElseComponent={({ children }) => <ArticleHeading3 color={'current_color'}>{children}</ArticleHeading3>}
        >
          {transformNumToString(+from) + '—' + transformNumToString(+to) + PERCENT}
        </ConditionalWrapper>
      </div>
    </>
  );
};
